import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink, { btnAccent, eyebrow } from './WaLink';
import { bridal } from '../data/salon';

const getPer = () => (
  typeof window === 'undefined' ? 3 : window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1
);

function BridalSlider() {
  const [per, setPer] = useState(getPer());
  const [i, setI] = useState(0);
  const max = bridal.length - per;

  useEffect(() => {
    const onResize = () => {
      setPer(getPer());
      setI(0);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setI((value) => (value >= max ? 0 : value + 1)), 5000);
    return () => clearInterval(timer);
  }, [max]);

  const go = (direction) => {
    setI((value) => (
      direction > 0 ? (value >= max ? 0 : value + 1) : (value <= 0 ? max : value - 1)
    ));
  };

  const arrow = 'grid h-12 w-12 place-items-center rounded-full border border-white/30 text-white transition hover:bg-[#E9A23B] hover:text-[#0B3B36]';

  return (
    <section id="bridal" className="bg-[#0B3B36] py-20 text-white">
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-6">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#E9A23B]">
              Bridal makeup showcase
            </span>
            <h2 className="font-display mt-3 text-4xl sm:text-5xl">
              Your big day,<em className="text-[#E9A23B]"> your glow.</em>
            </h2>
          </div>
          <div className="flex gap-3">
            <button type="button" className={arrow} aria-label="Previous slide" onClick={() => go(-1)}>
              <SafeIcon icon={FiIcons.FiArrowLeft} />
            </button>
            <button type="button" className={arrow} aria-label="Next slide" onClick={() => go(1)}>
              <SafeIcon icon={FiIcons.FiArrowRight} />
            </button>
          </div>
        </div>

        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-700 ease-out"
            style={{ transform: `translateX(-${i * (100 / per)}%)` }}
          >
            {bridal.map((item) => (
              <div key={item.title} className="shrink-0 px-2" style={{ width: `${100 / per}%` }}>
                <div className="relative h-[480px] overflow-hidden rounded-2xl sm:h-[540px]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover object-[center_25%]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#06201d]/85 via-transparent to-transparent" />
                  <h3 className="font-display absolute bottom-5 left-5 text-2xl">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 flex flex-col items-start gap-5">
          <div className="flex gap-2" aria-label="Choose a bridal slide">
            {Array.from({ length: max + 1 }).map((_, index) => (
              <button
                key={index}
                type="button"
                aria-label={`Go to slide ${index + 1}`}
                aria-current={i === index}
                onClick={() => setI(index)}
                className={`h-2.5 rounded-full transition-all ${i === index ? 'w-8 bg-[#E9A23B]' : 'w-2.5 bg-white/40'}`}
              />
            ))}
          </div>
          <WaLink className={btnAccent}>
            Enquire about bridal <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </WaLink>
        </div>
      </div>
    </section>
  );
}

export default BridalSlider;
